export const REGION_NOT_FOUND_ID = 999;

export const LEAD_QUERY_KEYS = {
  events: ['lead', 'events'],
  regions: ['lead', 'regions'],
  cities: (regionId) => ['lead', 'regions', regionId, 'cities'],
};

export const LEAD_MUTATION_KEYS = {
  create: ['lead', 'create'],
  postEvent: ['lead', 'events', 'post'],
  externalValidation: ['lead', 'external-validation'],
  validateIdentityNumber: ['lead', 'identity-number', 'validate'],
  uploadImage: ['lead', 'upload-image'],
};

export const STAGE_ALREADY_EXISTS = 'STAGE_ALREADY_EXISTS';

export const LEAD_EVENT_INVALID_RESPONSE = 'LEAD_EVENT_INVALID_RESPONSE';

export const EXTERNAL_VALIDATION_INVALID_RESPONSE =
  'EXTERNAL_VALIDATION_INVALID_RESPONSE';

export const CREATE_LEAD_MAGIC_LINK_SENT = 'MAGIC_LINK_SENT';
